<template>
  <div v-loading="loading" class="rt-table">
    <div v-if="hasHeader" class="rt-table-header">
      <slot name="header"></slot>
    </div>
    <div class="rt-table-content">
      <el-table
        v-if="autoHeight"
        ref="table"
        v-bind="$attrs"
        :stripe="stripe"
        :data="dataList"
        border
        class="rt-table-item"
        v-on="$listeners"
      >
        <template>
          <el-table-column v-if="sectionable" type="selection" width="48" />
          <slot />
        </template>
        <slot slot="empty" name="empty" />
      </el-table>
      <el-table
        v-else
        ref="table"
        v-bind="$attrs"
        :stripe="stripe"
        :data="dataList"
        border
        class="rt-table-item"
        v-on="$listeners"
      >
        <template>
          <el-table-column
            v-if="sectionable"
            :reserve-selection="true"
            type="selection"
            width="48"
          />
          <slot />
        </template>
        <slot slot="empty" name="empty" />
      </el-table>
      <div class="rt-table-pagination">
        <el-pagination
          v-if="showPagination && morePages"
          ref="pagination"
          :current-page="pageIndex"
          :page-size="pageSize"
          :page-sizes="pageSizes"
          :pager-count="pagerCount"
          :layout="pageLayout"
          :total="totalRecord"
          :background="pageBackground"
          @current-change="handleIndexChange"
          @size-change="handleSizeChange"
        />
        <div v-else class="total">{{ total }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { store } from './store';

const methods = [
  'clearSelection',
  'toggleRowSelection',
  'toggleAllSelection',
  'toggleRowExpansion',
  'setCurrentRow',
  'clearSort',
  'clearFilter',
  'doLayout',
  'sort'
];

export default {
  name: 'RtTable',
  props: {
    showPagination: {
      type: Boolean,
      default: true
    },
    totalRecord: {
      type: Number,
      default: 0
    },
    fetch: {
      type: Function,
      required: true
    },
    autoHeight: {
      type: Boolean,
      default: true
    },
    sectionable: {
      type: Boolean,
      default: true
    },
    stripe: {
      type: Boolean,
      default: true
    },
    pageLayout: {
      type: String,
      default: 'total, sizes, prev, pager, next, jumper'
    },
    pageBackground: {
      type: Boolean,
      default: true
    },
    pagerCount: Number,
    pageSize: {
      type: Number,
      default: 20
    },
    defaultPageIndex: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      pageIndex: this.defaultPageIndex,
      dataList: [],
      pageSizes: [5, 10, 20, 30, 40, 50],
      state: store.state,
      loading: false,
      morePages: false
    };
  },
  computed: {
    hasHeader() {
      return !!this.$slots.header;
    },
    total() {
      return `共 ${this.totalRecord} 条记录`;
    }
  },
  updated() {
    this.$nextTick(() => {
      if (this.$refs.pagination) {
        document.getElementsByClassName(
          'el-pagination__total'
        )[0].innerHTML = this.total;
      }
    });
  },
  mounted() {
    this.loadData();
    this.$nextTick(() => {
      // 将 elementui table 组件原生方法附加在 rtTable 上面
      methods.forEach(method => {
        this[method] = this.$refs.table[method];
      });
    });
  },
  methods: {
    loadData() {
      this.pageIndex = this.defaultPageIndex;
      this.fetchData();
    },
    fetchData() {
      this.loading = true;
      this.fetch({
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      })
        .then(resp => {
          // 处理返回结果
          this.dataList = resp || [];
          // 通过总数量与pageSize比较来判断是否显示分页
          this.morePages = this.totalRecord > this.pageSize ? true : false;
        })
        .then(() => {
          if (this.autoHeight) {
            this.$nextTick(() => {
              this.updateHeight();
              this.loading = false;
              this.$emit('load-complete');
            });
          } else {
            this.loading = false;
            this.$emit('load-complete');
          }
        });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.fetchData();
    },
    handleIndexChange(val) {
      this.pageIndex = val;
      this.fetchData();
    },
    updateHeight() {
      store.UPDATE_TABLE_HEIGHT();
    }
  }
};
</script>



// WEBPACK FOOTER //
// rtTable.vue?5dc65842